import { AsinRecommendation } from './asin-recommendation';

export { AsinRecommendation };
